import _defineProperty from "/Users/lianemeth/git/lianemeth.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var theme = {
  title: 'Nord',
  baseFontSize: '18px',
  baseLineHeight: '1.5',
  scaleRatio: 2,
  googleFonts: [{
    name: 'Rubik',
    styles: ['400']
  }],
  headerFontFamily: ['Rubik', 'sans-serif'],
  bodyFontFamily: ['Rubik', 'sans-serif'],
  bodyColor: '#434C5E',
  headerWeight: 700,
  bodyWeight: 400,
  boldWeight: 400,
  overrideStyles: function overrideStyles(_ref, options) {
    var adjustFontSizeTo = _ref.adjustFontSizeTo,
        scale = _ref.scale,
        rhythm = _ref.rhythm;
    return {
      'h1,h2,h3,h4,h5,h6': {
        lineHeight: 1.2
      },
      p: {
        margin: '1em 0'
      },
      a: {
        color: '#5E81AC',
        textDecoration: 'underline'
      },
      'a:hover,a:active': {
        color: '#81A1C1'
      },
      blockquote: _objectSpread(_objectSpread({}, scale(1 / 5)), {}, {
        color: '#4C566A',
        fontStyle: 'italic',
        paddingLeft: rhythm(13 / 16),
        marginLeft: 0,
        borderLeft: "".concat(rhythm(3 / 16), " solid #4C566A")
      }),
      'blockquote > :last-child': {
        marginBottom: 0
      },
      'blockquote cite': _objectSpread(_objectSpread({}, adjustFontSizeTo(options.baseFontSize)), {}, {
        color: options.bodyColor,
        fontWeight: options.bodyWeight
      }),
      'blockquote cite:before': {
        content: '"— "'
      }
    };
  }
};
export default theme;